import React from "react"
import { connect } from "react-redux"
import Modal from "../common/components/Modal"

import { questionAfterTerms } from "../identifiers/actions"
import { setTermModalShown, startOver } from "../interview/actions"
import { setTermsAgreed } from "../embed/actions"
import Link from "../common/components/Link"
import Text from "../common/components/Text"

const termsLink = "/terms/"
const privacyLink = "/privacy/"

const TermBody = ({ eulaLink, terms}) => (
  <Text>
    {!terms && <span>This tool is not intended to be a substitute for professional medical
      advice, diagnosis, or treatment.<br /></span>}
    <br />
    <p>
      By clicking "Agree & Continue" you attest that you are at least 13 years old and agree to Buoy Health’s{" "}
      <Link href={termsLink} target="_blank" rel="noopener noreferrer" size="bodyMain">
        Terms of Use
      </Link>
      {eulaLink ? ", " : " and "}
      <Link href={privacyLink} target="_blank" rel="noopener noreferrer" size="bodyMain">
        Privacy Policy
      </Link>
      {eulaLink ? ", and " : "."}
      {eulaLink ? (
        <Link href={eulaLink} target="_blank" rel="noopener noreferrer" size="bodyMain">
          End User Licensing Agreement
        </Link>
      ) : (
        ""
      )}
      {eulaLink && "."}
    </p>
  </Text>
)

const TermModal = ({ acceptTerms, show, visitChat, restart }) => {
  const settings = visitChat ? visitChat.settings : {}

  return show ? (
    <Modal
      heading=""
      body={settings.terms ? settings.terms : ""}
      buttonClick={acceptTerms}
      cancelClick={restart}
      buttonText={settings.eula_link || settings.require_terms ? "Agree & Continue" : "Okay"}
      showCancel={false}
      extraButtons={
        settings.eula_link || settings.require_terms
          ? [{ text: "Restart", negative: true, onClick: restart }]
          : []
      }
    >
      <TermBody eulaLink={settings.eula_link} terms={settings.terms} />
    </Modal>
  ) : (
    <span />
  )
}

const mapStateToProps = state => ({
  show: state.modals.termModalShown,
  visitChat: state.brand.visit_chat,
})

const mapDispatchToProps = dispatch => ({
  acceptTerms: () => {
    dispatch(setTermsAgreed(true))
    dispatch(setTermModalShown(false))
    dispatch(questionAfterTerms())
  },
  restart: () => {
    dispatch(setTermsAgreed(false))
    dispatch(startOver(true))
  },
})

const TermModalWrapper = connect(mapStateToProps, mapDispatchToProps)(TermModal)

export {TermModalWrapper as default, TermModal}



// WEBPACK FOOTER //
// ./assets/modals/TermModal.js